// serial 작품·회차 계약 (DEC-95 · DEC-101). 누구나 작품을 만들고 회차를 올리고, 로그인 없이 읽는다.
// 경로: POST /serial.v1.SerialService/<메서드>. 서비스 경로 전체가 optionalUser 뒤에 꽂히고(api/hooks.go publicRoutes),
// 로그인이 필요한 메서드는 서버가 첫 줄에서 httpapi.RPCUser 로 거른다 — 토큰이 없으면 unauthenticated.
//
// 오류: 코드 + 메시지 첫 낱말이 화면 문구 키다(api/internal/serial/rpc.go fail).
//   invalid_argument  invalid_field:<칸> · empty_body · too_short:<최소 글자 수>
//   permission_denied not_author
//   not_found         not_found
//   resource_exhausted daily_limit_reached:<하루 상한>

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file serial/v1/serial.proto (package serial.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file serial/v1/serial.proto.
 */
export const file_serial_v1_serial: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message serial.v1.Work
 */
export type Work = Message<"serial.v1.Work"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string synopsis = 3;
   */
  synopsis: string;

  /**
   * @generated from field: serial.v1.AiUsage ai_usage = 4;
   */
  aiUsage: AiUsage;

  /**
   * @generated from field: int32 episode_count = 5;
   */
  episodeCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * 로그인한 내가 쓴 작품인지 — 작가 식별자는 내려주지 않는다
   *
   * @generated from field: bool mine = 8;
   */
  mine: boolean;
};

/**
 * Describes the message serial.v1.Work.
 * Use `create(WorkSchema)` to create a new message.
 */
export const WorkSchema: GenMessage<Work> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 0);

/**
 * @generated from message serial.v1.EpisodeSummary
 */
export type EpisodeSummary = Message<"serial.v1.EpisodeSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 no = 2;
   */
  no: number;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * 공백을 뺀 글자 수
   *
   * @generated from field: int32 char_count = 4;
   */
  charCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 5;
   */
  publishedAt?: Timestamp | undefined;
};

/**
 * Describes the message serial.v1.EpisodeSummary.
 * Use `create(EpisodeSummarySchema)` to create a new message.
 */
export const EpisodeSummarySchema: GenMessage<EpisodeSummary> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 1);

/**
 * @generated from message serial.v1.Episode
 */
export type Episode = Message<"serial.v1.Episode"> & {
  /**
   * @generated from field: serial.v1.EpisodeSummary summary = 1;
   */
  summary?: EpisodeSummary | undefined;

  /**
   * @generated from field: string work_id = 2;
   */
  workId: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * 앞뒤 공개 회차, 없으면 빈 문자열
   *
   * @generated from field: string prev_id = 4;
   */
  prevId: string;

  /**
   * @generated from field: string next_id = 5;
   */
  nextId: string;

  /**
   * @generated from field: bool mine = 6;
   */
  mine: boolean;
};

/**
 * Describes the message serial.v1.Episode.
 * Use `create(EpisodeSchema)` to create a new message.
 */
export const EpisodeSchema: GenMessage<Episode> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 2);

/**
 * @generated from message serial.v1.ListWorksRequest
 */
export type ListWorksRequest = Message<"serial.v1.ListWorksRequest"> & {
  /**
   * 비면 첫 장
   *
   * @generated from field: string cursor = 1;
   */
  cursor: string;

  /**
   * 0 이면 기본 크기
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message serial.v1.ListWorksRequest.
 * Use `create(ListWorksRequestSchema)` to create a new message.
 */
export const ListWorksRequestSchema: GenMessage<ListWorksRequest> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 3);

/**
 * @generated from message serial.v1.ListWorksResponse
 */
export type ListWorksResponse = Message<"serial.v1.ListWorksResponse"> & {
  /**
   * @generated from field: repeated serial.v1.Work works = 1;
   */
  works: Work[];

  /**
   * 다음 장이 없으면 빈 문자열
   *
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;
};

/**
 * Describes the message serial.v1.ListWorksResponse.
 * Use `create(ListWorksResponseSchema)` to create a new message.
 */
export const ListWorksResponseSchema: GenMessage<ListWorksResponse> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 4);

/**
 * @generated from message serial.v1.GetWorkRequest
 */
export type GetWorkRequest = Message<"serial.v1.GetWorkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message serial.v1.GetWorkRequest.
 * Use `create(GetWorkRequestSchema)` to create a new message.
 */
export const GetWorkRequestSchema: GenMessage<GetWorkRequest> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 5);

/**
 * @generated from message serial.v1.GetWorkResponse
 */
export type GetWorkResponse = Message<"serial.v1.GetWorkResponse"> & {
  /**
   * @generated from field: serial.v1.Work work = 1;
   */
  work?: Work | undefined;

  /**
   * @generated from field: repeated serial.v1.EpisodeSummary episodes = 2;
   */
  episodes: EpisodeSummary[];
};

/**
 * Describes the message serial.v1.GetWorkResponse.
 * Use `create(GetWorkResponseSchema)` to create a new message.
 */
export const GetWorkResponseSchema: GenMessage<GetWorkResponse> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 6);

/**
 * @generated from message serial.v1.GetEpisodeRequest
 */
export type GetEpisodeRequest = Message<"serial.v1.GetEpisodeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message serial.v1.GetEpisodeRequest.
 * Use `create(GetEpisodeRequestSchema)` to create a new message.
 */
export const GetEpisodeRequestSchema: GenMessage<GetEpisodeRequest> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 7);

/**
 * @generated from message serial.v1.GetEpisodeResponse
 */
export type GetEpisodeResponse = Message<"serial.v1.GetEpisodeResponse"> & {
  /**
   * @generated from field: serial.v1.Episode episode = 1;
   */
  episode?: Episode | undefined;
};

/**
 * Describes the message serial.v1.GetEpisodeResponse.
 * Use `create(GetEpisodeResponseSchema)` to create a new message.
 */
export const GetEpisodeResponseSchema: GenMessage<GetEpisodeResponse> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 8);

/**
 * @generated from message serial.v1.CreateWorkRequest
 */
export type CreateWorkRequest = Message<"serial.v1.CreateWorkRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string synopsis = 2;
   */
  synopsis: string;

  /**
   * @generated from field: serial.v1.AiUsage ai_usage = 3;
   */
  aiUsage: AiUsage;
};

/**
 * Describes the message serial.v1.CreateWorkRequest.
 * Use `create(CreateWorkRequestSchema)` to create a new message.
 */
export const CreateWorkRequestSchema: GenMessage<CreateWorkRequest> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 9);

/**
 * @generated from message serial.v1.CreateWorkResponse
 */
export type CreateWorkResponse = Message<"serial.v1.CreateWorkResponse"> & {
  /**
   * @generated from field: serial.v1.Work work = 1;
   */
  work?: Work | undefined;
};

/**
 * Describes the message serial.v1.CreateWorkResponse.
 * Use `create(CreateWorkResponseSchema)` to create a new message.
 */
export const CreateWorkResponseSchema: GenMessage<CreateWorkResponse> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 10);

/**
 * @generated from message serial.v1.PublishEpisodeRequest
 */
export type PublishEpisodeRequest = Message<"serial.v1.PublishEpisodeRequest"> & {
  /**
   * @generated from field: string work_id = 1;
   */
  workId: string;

  /**
   * 비우면 「N화」
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;
};

/**
 * Describes the message serial.v1.PublishEpisodeRequest.
 * Use `create(PublishEpisodeRequestSchema)` to create a new message.
 */
export const PublishEpisodeRequestSchema: GenMessage<PublishEpisodeRequest> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 11);

/**
 * @generated from message serial.v1.PublishEpisodeResponse
 */
export type PublishEpisodeResponse = Message<"serial.v1.PublishEpisodeResponse"> & {
  /**
   * @generated from field: serial.v1.EpisodeSummary episode = 1;
   */
  episode?: EpisodeSummary | undefined;
};

/**
 * Describes the message serial.v1.PublishEpisodeResponse.
 * Use `create(PublishEpisodeResponseSchema)` to create a new message.
 */
export const PublishEpisodeResponseSchema: GenMessage<PublishEpisodeResponse> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 12);

/**
 * @generated from message serial.v1.RemoveWorkRequest
 */
export type RemoveWorkRequest = Message<"serial.v1.RemoveWorkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message serial.v1.RemoveWorkRequest.
 * Use `create(RemoveWorkRequestSchema)` to create a new message.
 */
export const RemoveWorkRequestSchema: GenMessage<RemoveWorkRequest> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 13);

/**
 * @generated from message serial.v1.RemoveWorkResponse
 */
export type RemoveWorkResponse = Message<"serial.v1.RemoveWorkResponse"> & {
};

/**
 * Describes the message serial.v1.RemoveWorkResponse.
 * Use `create(RemoveWorkResponseSchema)` to create a new message.
 */
export const RemoveWorkResponseSchema: GenMessage<RemoveWorkResponse> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 14);

/**
 * @generated from message serial.v1.RemoveEpisodeRequest
 */
export type RemoveEpisodeRequest = Message<"serial.v1.RemoveEpisodeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message serial.v1.RemoveEpisodeRequest.
 * Use `create(RemoveEpisodeRequestSchema)` to create a new message.
 */
export const RemoveEpisodeRequestSchema: GenMessage<RemoveEpisodeRequest> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 15);

/**
 * @generated from message serial.v1.RemoveEpisodeResponse
 */
export type RemoveEpisodeResponse = Message<"serial.v1.RemoveEpisodeResponse"> & {
};

/**
 * Describes the message serial.v1.RemoveEpisodeResponse.
 * Use `create(RemoveEpisodeResponseSchema)` to create a new message.
 */
export const RemoveEpisodeResponseSchema: GenMessage<RemoveEpisodeResponse> = /*@__PURE__*/
  messageDesc(file_serial_v1_serial, 16);

/**
 * AI 사용 정도 — 작품 단위로 작가가 밝힌다. DB works.ai_usage 의 none·assisted·generated 와 1:1
 *
 * @generated from enum serial.v1.AiUsage
 */
export enum AiUsage {
  /**
   * @generated from enum value: AI_USAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AI_USAGE_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: AI_USAGE_ASSISTED = 2;
   */
  ASSISTED = 2,

  /**
   * @generated from enum value: AI_USAGE_GENERATED = 3;
   */
  GENERATED = 3,
}

/**
 * Describes the enum serial.v1.AiUsage.
 */
export const AiUsageSchema: GenEnum<AiUsage> = /*@__PURE__*/
  enumDesc(file_serial_v1_serial, 0);

/**
 * @generated from service serial.v1.SerialService
 */
export const SerialService: GenService<{
  /**
   * 공개 작품 목록 — 최근 회차가 올라온 순. 로그인했으면 mine 이 채워진다
   *
   * @generated from rpc serial.v1.SerialService.ListWorks
   */
  listWorks: {
    methodKind: "unary";
    input: typeof ListWorksRequestSchema;
    output: typeof ListWorksResponseSchema;
  },
  /**
   * 공개 작품 + 공개 회차 목록(번호순)
   *
   * @generated from rpc serial.v1.SerialService.GetWork
   */
  getWork: {
    methodKind: "unary";
    input: typeof GetWorkRequestSchema;
    output: typeof GetWorkResponseSchema;
  },
  /**
   * 공개 회차 본문 + 앞뒤 공개 회차
   *
   * @generated from rpc serial.v1.SerialService.GetEpisode
   */
  getEpisode: {
    methodKind: "unary";
    input: typeof GetEpisodeRequestSchema;
    output: typeof GetEpisodeResponseSchema;
  },
  /**
   * 로그인 필요 — 작품 만들기. 만든 즉시 공개다
   *
   * @generated from rpc serial.v1.SerialService.CreateWork
   */
  createWork: {
    methodKind: "unary";
    input: typeof CreateWorkRequestSchema;
    output: typeof CreateWorkResponseSchema;
  },
  /**
   * 로그인 필요 — 내 작품에 회차 하나 공개. 회차 번호는 서버가 매긴다
   *
   * @generated from rpc serial.v1.SerialService.PublishEpisode
   */
  publishEpisode: {
    methodKind: "unary";
    input: typeof PublishEpisodeRequestSchema;
    output: typeof PublishEpisodeResponseSchema;
  },
  /**
   * 로그인 필요 — 내 작품 내리기(지우지 않고 숨김). 회차도 함께 안 보인다
   *
   * @generated from rpc serial.v1.SerialService.RemoveWork
   */
  removeWork: {
    methodKind: "unary";
    input: typeof RemoveWorkRequestSchema;
    output: typeof RemoveWorkResponseSchema;
  },
  /**
   * 로그인 필요 — 내 회차 하나 내리기. 번호는 다시 쓰지 않는다
   *
   * @generated from rpc serial.v1.SerialService.RemoveEpisode
   */
  removeEpisode: {
    methodKind: "unary";
    input: typeof RemoveEpisodeRequestSchema;
    output: typeof RemoveEpisodeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_serial_v1_serial, 0);

